import styled from 'styled-components';

export const Bottom = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const PaginationContainer = styled.div`
  text-align: right;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
  margin-bottom: 47px;
  span {
    font-size: 12px;
  }
  label {
    width: 100%;
    padding: 7px;
    padding-left: 18px;
  }
  .form-check-input {
    margin-left: -0.5rem;
    appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid #008aff;
    border-radius: 50%;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    :checked {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='2' fill='4e505a'/%3E%3C/svg%3E");
      border: 2px solid rgba(0, 138, 255, 0.5);
      background-color: #008aff;
    }
  }
  .form-check:hover {
    background-color: #4e505a;
  }
  .a_limit,
  .a_p_dec,
  .a_p_inc,
  .a_p_index {
    padding: 0;
    background: #181a21;
    border-radius: 3px;
    border: none;
    text-align: center;
    font-size: 16px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    margin-right: 8px;
    :hover {
      background: #008aff;
      color: #fff;
      border-radius: 3px;
      opacity: 1;
    }
  }
  .a_p_dec,
  .a_p_inc {
    width: 79px;
    height: 36px;
  }
  .a_p_index {
    width: 32px;
    height: 32px;
  }
  .a_p_active {
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-sizing: border-box;
    border-radius: 3px;
    background-color: transparent;
    :hover {
      background-color: transparent;
      border-color: #008aff;
    }
  }
  .a_limit {
    font-size: 12px;
    padding-left: 4px;
    padding-top: 2px;
    width: 27px;
    height: 27px;
    background: transparent;
  }
  .a_limit:hover,
  .a_limit:active,
  .a_limit:focus {
    font-size: 12px;
    background-color: #008aff;
    color: #dcdee1;
    border-radius: 3px;
  }
  .dropdown-menu {
    background-color: #2e3038;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.7);
    width: 125px;
    text-align: left;
    color: #fff;
    font-size: 12px;
    letter-spacing: 0.18px;
    line-height: 16px;
    min-width: 7rem;
  }
  .dropdown {
    display: inline-block;
  }
  #limitMenu::after {
    border: none;
  }
  @media screen and (max-width: 576px) {
    display: none;
  }
`;
